var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	52427: {
		fallback: () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	51263: {
		fallback: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	40147: {
		fallback: () => (__webpack_require__.e(322).then(() => (() => (__webpack_require__(85322))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",

	},
	45160: {
		fallback: () => (__webpack_require__.e(943).then(() => (() => (__webpack_require__(23943))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"263": [
		51263
	],
	"427": [
		52427
	],
	"908": [
		40147,
		45160
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}